"use client";

import { createContext } from "react";

/**
 * @typedef {object} UserContextValue
 * @prop {import("@cloudspire/shared/types/alfred/UserProfile").UserProfile} [user]
 * @prop {import("swr").KeyedMutator<import("@cloudspire/shared/hooks/useApiFetcher").ApiFetcherReturn<import("@cloudspire/shared/types/alfred/ApiResponse").Attr<import("@cloudspire/shared/types/alfred/UserProfile").UserProfile>>>} mutateUser
 */

export const UserContext = createContext(
  /** @type {UserContextValue | null} */ (null),
);
